import Vue from 'vue'
import axios from 'axios'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'

import devextreme from '@/plugins/devextreme'
import 'devextreme/dist/css/dx.common.css'

import firebase from 'firebase/app'
import 'firebase/auth'

import AuthApi from './api/AuthApi'

import AppModule from '@/store/modules/app.module'
import { getModule } from 'vuex-module-decorators'
import Store from '@/store'

const appModule = getModule(AppModule, Store)

Vue.use(devextreme)

Vue.config.productionTip = false

axios.interceptors.request.use(
  async (config) => {
    const user = await firebase.auth().currentUser
    const token = user ? await user.getIdToken(true) : ''
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

const authApi = new AuthApi()
let app: any
firebase.auth().onIdTokenChanged(async (user) => {
  if (user) {
    const userInfo = await authApi.getUserInfo(user.uid)
    const groups = await authApi.getGroups(userInfo)
    appModule.SET_GROUPS(groups)
  } else {
    appModule.SET_GROUPS([])
  }

  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount('#app')
  }
})
